/* Guide Ripcorde 5 semaines : rendu des vues à partir de window.GUIDE (data.js).
   Vues : #programme (accueil), #semaine-1 à #semaine-5, #exercices, #exercice-<id>, #suivi, #conseils, #avant, #faq, #suite, #garder. */
(function () {
  'use strict';
  var G = window.GUIDE;
  var CLE = 'ripcorde-guide-5s-v1';
  var vue = document.getElementById('guide-vue');
  var nav = document.getElementById('guide-nav');
  var reduit = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Suivi gardé sur le téléphone ---------- */
  var suivi = {};
  try { suivi = JSON.parse(localStorage.getItem(CLE) || '{}') || {}; } catch (e) { suivi = {}; }
  function sauver() { try { localStorage.setItem(CLE, JSON.stringify(suivi)); } catch (e) { /* stockage indisponible */ } }
  // « Ma raison » (conseil 1) : clé à part, pour que « Effacer mon suivi » ne l'efface pas.
  var CLE_RAISON = 'ripcorde-guide-5s-raison';
  var raison = '';
  try { raison = localStorage.getItem(CLE_RAISON) || ''; } catch (e) { raison = ''; }
  function sauverRaison() { try { localStorage.setItem(CLE_RAISON, raison); } catch (e) { /* stockage indisponible */ } }
  function ligne(n, id) { return suivi['S' + n + id] || {}; }
  function faites(n) { return G.semaines[n - 1].seances.filter(function (s) { return ligne(n, s.id).f; }).length; }
  function semaineCourante() {
    for (var i = 1; i <= 5; i++) { if (faites(i) < 3) return i; }
    return 5;
  }

  /* ---------- Outils ---------- */
  function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
  // Typographie française : espaces insécables avant : ; ? ! », après «, et entre un nombre et son unité.
  function typo(s) {
    return esc(s)
      .replace(/ ([:;?!»])/g, ' $1')
      .replace(/« /g, '« ')
      .replace(/(\d) (g|cm|min|s|kcal|kg|minutes|secondes|fois|blocs|jours)\b/g, '$1 $2');
  }
  function titre(a, accent) { return typo(a) + ' <em>' + typo(accent) + '</em>'; }
  function titreNom(nom) {
    var i = nom.lastIndexOf(' ');
    return i < 0 ? '<em>' + typo(nom) + '</em>' : typo(nom.slice(0, i)) + ' <em>' + typo(nom.slice(i + 1)) + '</em>';
  }
  function exo(id) { for (var i = 0; i < G.exercices.length; i++) { if (G.exercices[i].id === id) return G.exercices[i]; } return null; }
  // Emplacement des fichiers : dossier media/ en local, CDN Shopify sur ripcorde.com (window.GUIDE_MEDIA, posé par la section rc-guide).
  var M = window.GUIDE_MEDIA || {};
  function media(id, ext) { return (M.exo || 'media/') + id + '.' + ext; }
  function img(nom) { return M[nom] || 'media/' + nom; }
  function ico(nom) {
    var p = {
      liste: '<path d="M4 6h16M4 12h16M4 18h10"/>',
      grille: '<rect x="4" y="4" width="7" height="7" rx="1"/><rect x="13" y="4" width="7" height="7" rx="1"/><rect x="4" y="13" width="7" height="7" rx="1"/><rect x="13" y="13" width="7" height="7" rx="1"/>',
      coche: '<path d="M5 12l4 4 10-10"/>',
      retour: '<path d="M15 5l-7 7 7 7"/>',
      suivant: '<path d="M9 5l7 7-7 7"/>',
      alerte: '<circle cx="12" cy="12" r="9"/><path d="M12 7v6M12 17h.01"/>',
      garder: '<path d="M12 3v12M7 10l5 5 5-5M5 21h14"/>',
      question: '<circle cx="12" cy="12" r="9"/><path d="M9.5 9a2.5 2.5 0 1 1 3.5 2.3c-.6.3-1 .9-1 1.6V14M12 17h.01"/>',
      suite: '<path d="M5 12h14M13 6l6 6-6 6"/>',
      depart: '<path d="M6 21V4M6 4h11l-2 4 2 4H6"/>',
      conseil: '<path d="M9 18h6M10 21h4M12 3a6 6 0 0 0-3.5 10.9c.6.5 1 1.2 1 2.1h5c0-.9.4-1.6 1-2.1A6 6 0 0 0 12 3z"/>'
    }[nom];
    return '<svg class="ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + p + '</svg>';
  }
  function vignette(e, etiquette) {
    return '<a class="vign" href="#exercice-' + e.id + '"><img src="' + media(e.id, 'jpg') + '" alt="" loading="lazy" width="240" height="240">' +
      '<span class="vign-nom">' + typo(e.nom) + '</span>' + (etiquette ? '<span class="vign-sous">' + typo(etiquette) + '</span>' : '') + '</a>';
  }
  function video(e) {
    return '<div class="video"><video data-src="' + media(e.id, 'mp4') + '" poster="' + media(e.id, 'jpg') + '" muted loop playsinline preload="none"' +
      (reduit ? ' controls' : '') + ' aria-label="' + esc(e.nom + ', vidéo de démonstration de l\'appli') + '"></video>' +
      '<span class="video-etiq">Vidéo de l\'appli</span></div>';
  }
  function sautsSemaine(n) { var s = G.semaines[n - 1]; return s.sauts + ' de sauts par séance'; }

  /* ---------- Vues ---------- */
  function vProgramme() {
    var c = semaineCourante();
    var h = '<section class="hero">' +
      '<span class="pastille">Programme débutant</span>' +
      '<h1>' + titre(G.titre, G.titreAccent) + '</h1>' +
      '<p class="lead">' + typo(G.sousTitre) + '</p>' +
      '<img class="photo" src="' + img('photo-produit.jpg') + '" alt="Les poignées Ripcorde, leurs SmartBalls et l\'appli ouverte sur un téléphone" width="900" height="601">' +
      '<a class="btn" href="#semaine-' + c + '">' + (c === 1 && faites(1) === 0 ? 'Commencer la semaine 1' : 'Continuer la semaine ' + c) + '</a>' +
      '<a class="lien-seul" href="#avant">' + ico('depart') + 'Avant la première séance</a>' +
      '</section>';
    h += '<section class="bloc"><h2>Le <em>programme</em></h2><div class="carte liste">';
    G.semaines.forEach(function (s) {
      var f = faites(s.n), etat = f === 3 ? 'Terminée' : (s.n === c ? 'En cours' : '');
      h += '<a class="ligne-sem" href="#semaine-' + s.n + '"><span class="num' + (f === 3 || s.n === c ? ' num-plein' : '') + '">' + s.n + '</span>' +
        '<span class="ligne-txt"><span class="ligne-titre">Semaine ' + s.n + '</span><span class="ligne-sous">' + typo(sautsSemaine(s.n)) + ' · ' + f + '/3</span></span>' +
        (etat ? '<span class="etat">' + etat + '</span>' : '') + ico('suivant') + '</a>';
    });
    h += '</div></section>';
    h += '<section class="bloc"><h2>Le geste en <em>quatre points</em></h2><ul class="carte points">' +
      G.geste.map(function (g) { return '<li>' + ico('coche') + '<span><strong>' + typo(g.gras) + '</strong> ' + typo(g.texte) + '</span></li>'; }).join('') +
      '</ul></section>';
    h += '<section class="bloc"><div class="titre-ligne"><h2>Les <em>12 exercices</em></h2><a class="lien" href="#exercices">Tout voir</a></div><div class="grille3">' +
      ['basic-jump', 'boxer-step', 'freestyle-jump'].map(function (id) { return vignette(exo(id)); }).join('') + '</div></section>';
    h += blocAppli();
    h += '<section class="bloc"><div class="carte liste">' +
      '<a class="ligne-lien" href="#conseils">' + ico('conseil') + '<span>7 conseils pour garder le rythme</span>' + ico('suivant') + '</a>' +
      '<a class="ligne-lien" href="#faq">' + ico('question') + '<span>Questions fréquentes</span>' + ico('suivant') + '</a>' +
      '<a class="ligne-lien" href="#suite">' + ico('suite') + '<span>Après les 5 semaines</span>' + ico('suivant') + '</a>' +
      '<a class="ligne-lien" href="#garder">' + ico('garder') + '<span>Garder ce guide sur votre téléphone</span>' + ico('suivant') + '</a>' +
      '</div></section>';
    return h;
  }

  function blocAppli() {
    return '<section class="bloc"><div class="carte sauge appli"><p class="surtitre">Tout se lance dans l\'appli</p>' +
      '<p>' + typo('« Drills », puis « Intervals » : vous réglez la corde, le repos et le nombre de blocs. L\'appli compte vos sauts et vos jours actifs de la semaine.') + '</p>' +
      '<img src="' + img('capture-objectif.png') + '" alt="La carte « Objectif de la semaine » de l\'appli" width="640" height="296" loading="lazy">' +
      '<div class="stores"><a class="btn-sombre" href="' + G.appStore + '">App Store</a><a class="btn-sombre" href="' + G.playStore + '">Google Play</a></div></div></section>';
  }

  function vAvant() {
    var h = enTete('#programme', 'Programme') + '<section class="hero"><h1>Avant la <em>première séance</em></h1>' +
      '<p class="lead">' + typo('Comptez 10 minutes pour tout préparer, la première fois.') + '</p></section>';
    h += '<section class="bloc"><ol class="carte etapes">' + G.avant.map(function (a, i) {
      return '<li><span class="num num-plein">' + (i + 1) + '</span><span><strong>' + typo(a.titre) + '</strong><br>' + typo(a.texte) + '</span></li>';
    }).join('') + '</ol></section>';
    h += '<section class="bloc"><figure class="capture"><img src="' + img('capture-connexion.png') + '" alt="L\'écran « Connectez votre RIPCORDE » de l\'appli" loading="lazy">' +
      '<figcaption>' + typo('L\'écran de connexion de l\'appli : bouton ON/OFF de la poignée, puis « Connecter ma Ripcorde ».') + '</figcaption></figure></section>';
    h += '<section class="bloc"><h2>Le geste en <em>quatre points</em></h2><ul class="carte points">' +
      G.geste.map(function (g) { return '<li>' + ico('coche') + '<span><strong>' + typo(g.gras) + '</strong> ' + typo(g.texte) + '</span></li>'; }).join('') +
      '</ul></section>';
    h += '<section class="bloc"><a class="btn" href="#semaine-1">Commencer la semaine 1</a></section>';
    return h;
  }

  function tableSuivi(n) {
    var s = G.semaines[n - 1];
    var h = '<div class="carte table-suivi" role="group" aria-label="Suivi de la semaine ' + n + '">' +
      '<div class="ts-tete"><span></span><span>Séance</span><span>Date</span><span>Sauts</span></div>';
    s.seances.forEach(function (se) {
      var l = ligne(n, se.id), k = 'S' + n + se.id;
      h += '<div class="ts-ligne' + (l.f ? ' ts-faite' : '') + '">' +
        '<span class="ts-case"><input type="checkbox" id="c-' + k + '" data-k="' + k + '"' + (l.f ? ' checked' : '') + '></span>' +
        '<label for="c-' + k + '" class="ts-seance"><span class="ts-titre">' + typo(se.titre) + '</span><span class="ts-texte">' + typo(se.texte) + '</span></label>' +
        '<span><input class="ts-champ" type="text" id="d-' + k + '" data-k="' + k + '" data-c="d" value="' + esc(l.d || '') + '" placeholder="jj/mm" aria-label="Date de la ' + typo(se.titre).toLowerCase() + ', semaine ' + n + '" inputmode="numeric" maxlength="5"></span>' +
        '<span><input class="ts-champ ts-num" type="text" id="s-' + k + '" data-k="' + k + '" data-c="s" value="' + esc(l.s || '') + '" placeholder="0" aria-label="Sauts de la ' + typo(se.titre).toLowerCase() + ', semaine ' + n + '" inputmode="numeric" maxlength="5"></span>' +
        '</div>';
    });
    return h + '</div>';
  }

  function vSemaine(n) {
    var s = G.semaines[n - 1];
    var h = '<nav class="onglets-sem" aria-label="Semaines">' + G.semaines.map(function (x) {
      var f = faites(x.n) === 3;
      return '<a href="#semaine-' + x.n + '" class="' + (x.n === n ? 'actif' : '') + (f ? ' fait' : '') + '"' + (x.n === n ? ' aria-current="page"' : '') + '>S' + x.n + (f ? ico('coche') : '') + '</a>';
    }).join('') + '</nav>';
    h += '<section class="hero"><p class="surtitre">Semaine ' + n + ' sur 5</p><h1>' + titre(s.titre, s.titreAccent) + '</h1>' +
      '<p class="lead">' + typo(s.intro) + '</p><p class="discret">' + typo(s.duree) + '</p></section>';
    h += '<section class="bloc"><div class="reglage"><p class="reglage-ou">Dans l\'appli · ' + typo(s.reglage.ou) + '</p><div class="reglage-cases">' +
      s.reglage.cases.map(function (c, i) { return '<div class="reglage-case"><span class="reglage-v' + (i === 2 ? ' sauge-txt' : '') + '">' + typo(c.v) + '</span><span class="reglage-l">' + typo(c.l) + '</span></div>'; }).join('') +
      '</div><p class="reglage-note">' + typo(s.reglage.note) + '</p></div></section>';
    h += '<section class="bloc"><h2>Vos 3 <em>séances</em></h2>' + tableSuivi(n) +
      '<p class="discret">' + typo('Un jour de repos entre deux séances. Les sauts s\'affichent sur la poignée et dans l\'appli. Vos cases restent sur ce téléphone.') + '</p></section>';
    h += '<section class="bloc"><h2>Les sauts <em>de la semaine</em></h2><div class="grille3">' +
      s.exos.map(function (id) { var e = exo(id); return vignette(e, e.semaine === n && n > 1 ? 'Nouveau' : ''); }).join('') + '</div></section>';
    if (n < 5) {
      h += '<section class="bloc"><div class="carte sauge"><p class="surtitre">Passer à la semaine ' + (n + 1) + ' ?</p><p>' + typo(G.passage) + '</p></div>' +
        '<a class="btn" href="#semaine-' + (n + 1) + '">Semaine ' + (n + 1) + '</a></section>';
    } else {
      h += '<section class="bloc"><div class="carte sauge"><p class="surtitre">Et après ?</p><p>' + typo('Les séances guidées, les SmartBalls plus lourdes, la corde traditionnelle : tout est dans la page suivante.') + '</p></div>' +
        '<a class="btn" href="#suite">Après les 5 semaines</a></section>';
    }
    return h;
  }

  function vExercices() {
    var h = '<section class="hero"><h1>Les <em>12 exercices</em></h1><p class="lead">' +
      typo('Les mouvements de corde des séances de l\'appli, avec leur nom dans l\'appli. Touchez un exercice pour voir la vidéo et les consignes.') + '</p></section>';
    ['debutant', 'intermediaire', 'avance'].forEach(function (niv) {
      var l = G.exercices.filter(function (e) { return e.niveau === niv; });
      h += '<section class="bloc"><h2 class="h-niveau">' + G.niveaux[niv] + ' <span>' + l.length + '</span></h2><div class="carte liste">' +
        l.map(function (e) {
          return '<a class="ligne-exo" href="#exercice-' + e.id + '"><img src="' + media(e.id, 'jpg') + '" alt="" loading="lazy" width="112" height="112">' +
            '<span class="ligne-txt"><span class="ligne-titre">' + typo(e.nom) + '</span><span class="ligne-sous">' + typo(e.appli) + ' · ' +
            (e.semaine ? 'semaine ' + e.semaine : 'séances guidées') + '</span></span>' + ico('suivant') + '</a>';
        }).join('') + '</div></section>';
    });
    return h;
  }

  function vExercice(id) {
    var e = exo(id);
    if (!e) return vExercices();
    var i = G.exercices.indexOf(e), prec = G.exercices[(i + G.exercices.length - 1) % G.exercices.length], suiv = G.exercices[(i + 1) % G.exercices.length];
    var h = enTete('#exercices', 'Exercices', (i + 1) + ' sur 12');
    h += '<section class="bloc premier">' + video(e) + '</section>';
    h += '<section class="hero hero-serre"><div class="pastilles"><span class="pastille">' + G.niveaux[e.niveau] + '</span>' +
      '<span class="pastille">' + (e.semaine ? 'Dès la semaine ' + e.semaine : 'Dans les séances guidées') + '</span></div>' +
      '<h1>' + titreNom(e.nom) + '</h1><p class="discret">Dans l\'appli : <strong>' + typo(e.appli) + '</strong></p><p class="lead">' + typo(e.resume) + '</p></section>';
    h += '<section class="bloc"><h2>Comment <em>faire</em></h2><ol class="carte etapes">' + e.etapes.map(function (t, k) {
      return '<li><span class="num num-plein">' + (k + 1) + '</span><span>' + typo(t) + '</span></li>';
    }).join('') + '</ol>' +
      '<div class="alerte">' + ico('alerte') + '<span><span class="surtitre">L\'erreur fréquente</span>' + typo(e.erreur) + '</span></div></section>';
    h += '<section class="bloc"><h2>À enchaîner <em>avec</em></h2><div class="grille2">' + e.enchainer.map(function (x) {
      var o = exo(x); return '<a class="mini" href="#exercice-' + o.id + '"><img src="' + media(o.id, 'jpg') + '" alt="" loading="lazy" width="104" height="104"><span>' + typo(o.nom) + '</span></a>';
    }).join('') + '</div></section>';
    h += '<section class="bloc"><div class="grille2"><a class="btn btn-clair" href="#exercice-' + prec.id + '">Précédent</a><a class="btn" href="#exercice-' + suiv.id + '">Suivant</a></div></section>';
    return h;
  }

  function vSuivi() {
    var total = 0; G.semaines.forEach(function (s) { total += faites(s.n); });
    var h = '<section class="hero"><h1>Mon <em>suivi</em></h1><p class="lead">' + typo('Cochez chaque séance terminée et notez vos sauts. Tout reste sur ce téléphone, dans ce navigateur.') + '</p>' +
      '<div class="compteur"><span class="compteur-v">' + total + '<small>/15</small></span><span class="compteur-l">séances faites</span>' +
      '<span class="barre" role="img" aria-label="' + total + ' séances sur 15"><span style="width:' + Math.round(total / 15 * 100) + '%"></span></span></div></section>';
    h += '<section class="bloc">' + (raison
      ? '<div class="carte sauge"><p class="surtitre">Ma raison</p><p class="raison-txt">' + esc(raison) + '</p><a class="lien" href="#conseils">Modifier</a></div>'
      : '<a class="lien-seul" href="#conseils">' + ico('conseil') + 'Écrire ma raison</a>') + '</section>';
    G.semaines.forEach(function (s) {
      h += '<section class="bloc"><div class="titre-ligne"><h2>Semaine <em>' + s.n + '</em></h2><a class="lien" href="#semaine-' + s.n + '">Voir la semaine</a></div>' + tableSuivi(s.n) + '</section>';
    });
    h += '<section class="bloc"><div id="guide-raz-zone"><button type="button" class="btn btn-clair" id="guide-raz">Effacer mon suivi</button></div></section>';
    return h;
  }

  function vConseils() {
    var C = G.conseils;
    var h = '<section class="hero"><h1>' + titre(C.titre, C.titreAccent) + '</h1><p class="lead">' + typo(C.intro) + '</p></section>';
    C.liste.forEach(function (c, i) {
      h += '<section class="bloc"><div class="conseil-tete"><span class="num num-plein">' + (i + 1) + '</span><h2>' + titre(c.titre, c.accent) + '</h2></div>' +
        '<div class="carte conseil">' + c.texte.map(function (t) { return '<p>' + typo(t) + '</p>'; }).join('');
      if (c.pourquoi) {
        h += '<ol class="pourquoi">' + c.pourquoi.map(function (x) { return '<li><span class="pq-q">' + typo(x.q) + '</span><span class="pq-r">' + typo(x.r) + '</span></li>'; }).join('') + '</ol>';
      }
      h += '<div class="a-faire"><span class="surtitre">À faire</span><p>' + typo(c.faire) + '</p>';
      if (c.raison) {
        h += '<label class="raison-l" for="guide-raison">Ma raison</label><textarea id="guide-raison" class="raison-champ" rows="3" maxlength="280" placeholder="' + esc('Je fais de la corde à sauter pour…') + '">' + esc(raison) + '</textarea>' +
          '<p class="discret">' + typo('Elle reste sur ce téléphone, dans ce navigateur.') + '</p>';
      }
      h += '</div>';
      if (c.plus) h += '<p class="discret">' + typo(c.plus) + '</p>';
      if (c.lien) h += '<a class="lien" href="' + c.lien.href + '">' + typo(c.lien.texte) + '</a>';
      h += '</div>';
      if (c.avis) h += '<figure class="avis"><blockquote>' + typo('« ' + c.avis.texte + ' »') + '</blockquote><figcaption>' + typo(c.avis.auteur) + '</figcaption></figure>';
      h += '</section>';
    });
    h += '<section class="bloc"><p class="discret">' + typo(C.source) + '</p></section>';
    return h + blocContact();
  }

  function vFaq() {
    var h = enTete('#programme', 'Programme') + '<section class="hero"><h1>Questions <em>fréquentes</em></h1></section><section class="bloc"><div class="carte liste">';
    G.faq.forEach(function (f, i) {
      h += '<details class="faq"' + (i === 0 ? ' open' : '') + '><summary>' + typo(f.q) + ico('suivant') + '</summary><p>' + typo(f.r) + '</p>' +
        (f.note ? '<p class="discret">' + typo(f.note) + '</p>' : '') + '</details>';
    });
    h += '</div></section>' + blocContact();
    return h;
  }

  function vSuite() {
    var h = enTete('#programme', 'Programme') + '<section class="hero"><h1>Après les <em>5 semaines</em></h1>' +
      '<p class="lead">' + typo('Vous tenez dix minutes de sauts. Voici comment continuer à progresser.') + '</p></section>';
    h += '<section class="bloc"><div class="carte liste">' + G.suite.map(function (s) {
      return '<div class="suite-ligne"><p class="ligne-titre">' + typo(s.titre) + '</p><p>' + typo(s.texte) + '</p></div>';
    }).join('') + '</div></section>';
    h += '<section class="bloc"><div class="grille3">' + ['high-knees', 'balancing-jump', 'double-unders'].map(function (id) { return vignette(exo(id), 'Avancé'); }).join('') + '</div></section>';
    return h + blocAppli();
  }

  function vGarder() {
    var h = enTete('#programme', 'Programme') + '<section class="hero"><h1>Garder <em>ce guide</em></h1>' +
      '<p class="lead">' + typo('Ajoutez-le à l\'écran d\'accueil de votre téléphone : il s\'ouvre comme une appli, en un geste.') + '</p></section>';
    h += '<section class="bloc"><ol class="carte etapes">' +
      '<li><span class="num num-plein">1</span><span><strong>Sur iPhone, dans Safari</strong><br>' + typo('Touchez le bouton Partager, puis « Sur l\'écran d\'accueil ».') + '</span></li>' +
      '<li><span class="num num-plein">2</span><span><strong>Sur Android, dans Chrome</strong><br>' + typo('Touchez le menu en haut à droite, puis « Ajouter à l\'écran d\'accueil ».') + '</span></li>' +
      '</ol><p class="discret">' + typo('Vos cases cochées restent dans ce navigateur, sur ce téléphone. Gardez aussi l\'e-mail qui vous a envoyé ce guide : le lien y est.') + '</p></section>';
    return h + blocContact();
  }

  function blocContact() {
    return '<section class="bloc"><div class="carte contact"><p class="surtitre">Une question ?</p><p>' +
      typo('Répondez à l\'e-mail qui vous a envoyé ce guide, ou écrivez-nous : notre équipe vous répond personnellement.') + '</p>' +
      '<div class="copie"><span id="guide-mail" class="mail">' + esc(G.contact) + '</span><button type="button" class="btn-sombre" id="guide-copier">Copier</button></div></div></section>';
  }

  function enTete(href, texte, droite) {
    return '<div class="fil"><a href="' + href + '">' + ico('retour') + typo(texte) + '</a>' + (droite ? '<span>' + droite + '</span>' : '') + '</div>';
  }

  /* ---------- Routage ---------- */
  function rendre() {
    var h = (location.hash || '').replace('#', '');
    var m, html, onglet = 'programme';
    if ((m = /^semaine-([1-5])$/.exec(h))) html = vSemaine(+m[1]);
    else if ((m = /^exercice-([a-z-]+)$/.exec(h))) { html = vExercice(m[1]); onglet = 'exercices'; }
    else if (h === 'exercices') { html = vExercices(); onglet = 'exercices'; }
    else if (h === 'suivi') { html = vSuivi(); onglet = 'suivi'; }
    else if (h === 'conseils') { html = vConseils(); onglet = 'conseils'; }
    else if (h === 'avant') html = vAvant();
    else if (h === 'faq') html = vFaq();
    else if (h === 'suite') html = vSuite();
    else if (h === 'garder') html = vGarder();
    else html = vProgramme();
    vue.innerHTML = html;
    [].forEach.call(nav.querySelectorAll('a'), function (a) {
      var actif = a.getAttribute('data-onglet') === onglet;
      a.classList.toggle('actif', actif);
      if (actif) a.setAttribute('aria-current', 'page'); else a.removeAttribute('aria-current');
    });
    brancher();
    window.scrollTo(0, 0);
  }

  var observateur = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entrees) {
    entrees.forEach(function (en) {
      var v = en.target;
      if (en.isIntersecting) {
        if (!v.src) v.src = v.getAttribute('data-src');
        if (!reduit) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      } else if (!v.paused) v.pause();
    });
  }, { threshold: 0.3 }) : null;

  function brancher() {
    [].forEach.call(vue.querySelectorAll('video[data-src]'), function (v) {
      if (observateur) observateur.observe(v); else { v.src = v.getAttribute('data-src'); if (!reduit) v.play(); }
    });
    [].forEach.call(vue.querySelectorAll('input[type=checkbox][data-k]'), function (c) {
      c.addEventListener('change', function () {
        var k = c.getAttribute('data-k'), l = suivi[k] || {};
        l.f = c.checked ? 1 : 0;
        if (c.checked && !l.d) {
          var d = new Date(); l.d = ('0' + d.getDate()).slice(-2) + '/' + ('0' + (d.getMonth() + 1)).slice(-2);
          var champ = document.getElementById('d-' + k); if (champ) champ.value = l.d;
        }
        suivi[k] = l; sauver();
        var lg = c.closest('.ts-ligne'); if (lg) lg.classList.toggle('ts-faite', c.checked);
      });
    });
    [].forEach.call(vue.querySelectorAll('input.ts-champ'), function (ch) {
      ch.addEventListener('input', function () {
        var k = ch.getAttribute('data-k'), l = suivi[k] || {};
        l[ch.getAttribute('data-c')] = ch.value.trim(); suivi[k] = l; sauver();
      });
    });
    var champRaison = document.getElementById('guide-raison');
    if (champRaison) champRaison.addEventListener('input', function () { raison = champRaison.value.trim(); sauverRaison(); });
    var copier = document.getElementById('guide-copier');
    if (copier) copier.addEventListener('click', function () {
      var ok = function () { copier.textContent = 'Copié'; };
      var repli = function () { var r = document.createRange(); r.selectNodeContents(document.getElementById('guide-mail')); var s = window.getSelection(); s.removeAllRanges(); s.addRange(r); copier.textContent = 'Sélectionné'; };
      try { navigator.clipboard.writeText(G.contact).then(ok, repli); } catch (e) { repli(); }
    });
    var raz = document.getElementById('guide-raz');
    if (raz) raz.addEventListener('click', function () {
      document.getElementById('guide-raz-zone').innerHTML = '<div class="carte confirme"><p>' + typo('Effacer toutes les cases et tous les sauts notés ? C\'est définitif.') + '</p>' +
        '<div class="grille2"><button type="button" class="btn btn-clair" id="guide-raz-non">Annuler</button><button type="button" class="btn" id="guide-raz-oui">Effacer</button></div></div>';
      document.getElementById('guide-raz-non').addEventListener('click', rendre);
      document.getElementById('guide-raz-oui').addEventListener('click', function () { suivi = {}; sauver(); rendre(); });
    });
  }

  window.addEventListener('hashchange', rendre);
  rendre();
})();
